import { strings } from "assets/constants";
import toast from "components/toast";

const alertPermission = () => {
  toast.warning({ message: strings.permission_denied });
  return;
};

export default alertPermission;
